import React from 'react'
import { Flags } from 'react-feature-flags'

import Modal from './Modal'

export default () => {
    return (
        <Modal>
            <header>
                <h2>Print Map</h2>
                <p>Upon clicking the button below, you will be redirected to your browser's print window. </p>
            </header>
            <h3>For best results:</h3>
            <p>
                <ul>
                    <li>
                        Change the layout to <strong>Landscape</strong>
                    </li>
                    <li>
                        (Chrome) Make sure to open <strong>More Settings</strong>, then click{' '}
                        <strong>Background Graphics</strong>
                    </li>
                    <li>
                        (Safari & Firefox) Click on <strong>Print Backgrounds</strong>
                    </li>
                    <li>
                        (Edge) Make sure to open <strong>Options</strong>, then click{' '}
                        <strong>Background Graphics</strong>
                    </li>
                </ul>
            </p>
            <button type="button" className="button is-primary" onClick={() => window.print()}>
                Print Map
            </button>
        </Modal>
    )
}
